import { Box } from 'approot/shared/design-system/box/box.style';
import SuggestedAnswerScoreView from './suggested-answer-score-view';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';

type Props = {
  isExampleAnswer?: boolean;
  isFixedAnswer?: boolean;
  isUnitQuiz: boolean;
  suggestedAnswerScore?: number | null;
};

const SuggestedAnswerViewBadges = ({
  isExampleAnswer,
  isFixedAnswer,
  suggestedAnswerScore,
  isUnitQuiz,
}: Props) => {
  return (
    <Box $gap={8} $marginBottom={12}>
      {isExampleAnswer && (
        <BadgeSmallStyled data-selector="lbl-example-answer">
          Example Answer
        </BadgeSmallStyled>
      )}
      {isFixedAnswer && (
        <BadgeSmallStyled data-selector="lbl-fixed-answer">
          Fixed Answer
        </BadgeSmallStyled>
      )}
      {isUnitQuiz && <SuggestedAnswerScoreView score={suggestedAnswerScore} />}
    </Box>
  );
};

export default SuggestedAnswerViewBadges;
